import { create } from 'zustand';
import { persist } from 'zustand/middleware';
interface StationState { currentStationId: string | null; stationName: string | null; setStation: (id: string, name: string) => void; clearStation: () => void; }
export const useStationStore = create<StationState>()(persist((set) => ({
  currentStationId: null, stationName: null,
  setStation: (id, name) => set({ currentStationId: id, stationName: name }),
  clearStation: () => set({ currentStationId: null, stationName: null }),
}), { name: 'amarfuel-station' }));
